import { ALL_SKILLS } from "./skills-Dj4T8Duc.js";
import { defineTool } from "./define-SD6AQa4b.js";
import { apiServiceFromContext } from "./api-EaEPyKlQ.js";
import { structuredResult } from "./results-NF1RJbDZ.js";
import { z } from "zod";

//#region src/tools/catalog/whoami.ts
const whoamiOutputSchema = z.object({
	user: z.object({
		id: z.string(),
		name: z.string().nullable(),
		email: z.string()
	}),
	sessionConstraints: z.object({
		organizationSlug: z.string().optional(),
		projectSlug: z.string().optional(),
		regionUrl: z.string().optional()
	}).nullable()
});
var whoami_default = defineTool({
	name: "whoami",
	description: [
		"Identify the authenticated user in Sentry.",
		"",
		"Use this tool when you need to:",
		"- Get the user's name and email address."
	].join("\n"),
	inputSchema: {},
	outputSchema: whoamiOutputSchema,
	skills: ALL_SKILLS,
	requiredScopes: [],
	annotations: {
		readOnlyHint: true,
		destructiveHint: false,
		openWorldHint: true
	},
	async handler(params, context) {
		const apiService = apiServiceFromContext(context);
		const user = await apiService.getAuthenticatedUser();
		const constraints = context.constraints;
		const sessionConstraints = constraints.organizationSlug || constraints.projectSlug || constraints.regionUrl ? {
			...constraints.organizationSlug ? { organizationSlug: constraints.organizationSlug } : {},
			...constraints.projectSlug ? { projectSlug: constraints.projectSlug } : {},
			...constraints.regionUrl ? { regionUrl: constraints.regionUrl } : {}
		} : null;
		return structuredResult({
			user: {
				id: String(user.id),
				name: user.name ?? null,
				email: user.email
			},
			sessionConstraints
		});
	}
});

//#endregion
export { whoamiOutputSchema, whoami_default };
//# sourceMappingURL=whoami-Bz6QKirR.js.map